export function sendGaPageView(pageName) {
  if (window.ga) {
    window.ga('send', 'pageview', pageName);
  }
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js